import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { isNil } from "lopermut"
import { getSentimentColor, getSentimentLabel } from "modules/shared/lib/sentiment"
import { useTranslation } from "react-i18next"
import { SentimentIcon } from "./SentimentIcon"

// Full class names so Tailwind can detect them
const COLORED_CLASS_NAMES: Record<string, string> = {
  negative: "border-negative text-negative",
  "negative-soft": "border-negative-soft text-negative-soft",
  neutral: "border-neutral text-neutral",
  "positive-soft": "border-positive-soft text-positive-soft",
  positive: "border-positive text-positive",
}

type Props = {
  sentiment: number | undefined | null
  /** Tints the badge and its icon with the sentiment color */
  colored?: boolean
}

export const SentimentBadge = ({ sentiment, colored = false }: Props) => {
  const { t } = useTranslation()

  if (isNil(sentiment)) {
    return <span className="text-muted-foreground">{"-"}</span>
  }

  return (
    <Badge
      variant="outline"
      className={cn(
        "whitespace-nowrap",
        colored && COLORED_CLASS_NAMES[getSentimentColor(sentiment)],
      )}
    >
      <div className="flex flex-row gap-1.5 items-center">
        <SentimentIcon
          sentiment={sentiment}
          className={colored ? undefined : "text-muted-foreground"}
          size={14}
        />
        <span>{getSentimentLabel(sentiment, t)}</span>
      </div>
    </Badge>
  )
}
